import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../../../const/axios'

const pretty = (obj: any) => JSON.stringify(obj, null, 2)

const ProfileAppeals: React.FC = () => {
  const [hasAccess, setHasAccess] = useState(false)
  const [checkedAccess, setCheckedAccess] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [appealTournamentId, setAppealTournamentId] = useState('')
  const [appealReason, setAppealReason] = useState('')
  const [resolveAppealId, setResolveAppealId] = useState('')
  const [resolveAccept, setResolveAccept] = useState(true)
  const [resolveNotes, setResolveNotes] = useState('')

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const res = await api.get('/users/organizer/me')
        setHasAccess(!!res.data?.isOrganizer)
      } catch {
        setHasAccess(false)
      } finally {
        setCheckedAccess(true)
      }
    }

    checkAccess()
  }, [])

  const handleAppealCreate = async () => {
    setMessage('')
    setError('')
    try {
      const res = await api.post('/appeals', {
        tournamentId: Number(appealTournamentId),
        reason: appealReason,
      })
      setMessage(`Appeal yaradıldı: ${pretty(res.data)}`)
    } catch (err: any) {
      setError(err?.response?.data || 'Appeal yaradılmadı.')
    }
  }

  const handleAppealResolve = async () => {
    setMessage('')
    setError('')
    try {
      const res = await api.post(`/appeals/${resolveAppealId}/resolve`, {
        accept: resolveAccept,
        resolutionNotes: resolveNotes,
      })
      setMessage(`Appeal cavablandı: ${pretty(res.data)}`)
    } catch (err: any) {
      setError(err?.response?.data || 'Appeal cavablandırılmadı.')
    }
  }

  const input = 'w-full border border-slate-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 placeholder:text-gray-400 dark:placeholder:text-gray-500 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/40'

  if (!checkedAccess) {
    return (
      <div className="min-h-screen bg-slate-50 pt-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <p className="text-sm text-slate-600 dark:text-gray-300">Yoxlanılır...</p>
        </div>
      </div>
    )
  }

  if (!hasAccess) {
    return (
      <div className="min-h-screen bg-slate-50 pt-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-3">
          <h1 className="text-2xl font-black text-slate-900">Appeals</h1>
          <p className="text-sm text-rose-700">Bu səhifə yalnız organizer və yuxarı rollar üçündür.</p>
          <Link to="/profile" className="text-sm text-blue-700 dark:text-indigo-300">Profilə qayıt</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-slate-50 pt-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-black text-slate-900">Appeals</h1>
          <Link to="/profile" className="text-sm text-blue-700 dark:text-indigo-300">Profil</Link>
        </div>

        {message ? <pre className="text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 p-3 rounded-lg overflow-auto">{message}</pre> : null}
        {error ? <p className="text-sm text-red-600">{String(error)}</p> : null}

        <section className="bg-white dark:bg-gray-900 rounded-2xl border border-slate-100 shadow-sm p-4 space-y-3">
          <p className="text-sm font-semibold text-slate-700">Yeni appeal</p>
          <input className={input} placeholder="Tournament ID" value={appealTournamentId} onChange={(e) => setAppealTournamentId(e.target.value)} />
          <textarea className={`${input} min-h-[100px]`} placeholder="Reason" value={appealReason} onChange={(e) => setAppealReason(e.target.value)} />
          <button onClick={handleAppealCreate} className="bg-emerald-700 text-white px-3 py-2 rounded-lg text-sm font-semibold">Appeal yarat</button>
        </section>

        <section className="bg-white dark:bg-gray-900 rounded-2xl border border-slate-100 shadow-sm p-4 space-y-3">
          <p className="text-sm font-semibold text-slate-700">Appeal cavablandır</p>
          <input className={input} placeholder="Appeal ID" value={resolveAppealId} onChange={(e) => setResolveAppealId(e.target.value)} />
          <select className={input} value={resolveAccept ? 'true' : 'false'} onChange={(e) => setResolveAccept(e.target.value === 'true')}>
            <option value="true">Accept</option>
            <option value="false">Reject</option>
          </select>
          <textarea className={`${input} min-h-[90px]`} placeholder="Resolution notes" value={resolveNotes} onChange={(e) => setResolveNotes(e.target.value)} />
          <button onClick={handleAppealResolve} className="bg-amber-700 text-white px-3 py-2 rounded-lg text-sm font-semibold">Resolve appeal</button>
        </section>
      </div>
    </div>
  )
}

export default ProfileAppeals
